import { ChangeDetectionStrategy, Component, OnChanges, OnDestroy, OnInit, inject, input } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { DirectivesModule } from 'ish-core/directives.module';
import { ShoppingFacade } from 'ish-core/facades/shopping.facade';
import { FeatureToggleModule } from 'ish-core/feature-toggle.module';
import { CategoryView } from 'ish-core/models/category-view/category-view.model';
import { ProductListingView } from 'ish-core/models/product-listing/product-listing.model';
import { DeviceType } from 'ish-core/models/viewtype/viewtype.types';
import { SharedModule } from 'ish-shared/shared.module';

import { CategoryListComponent } from '../category-list/category-list.component';
import { ProductLinksComponent } from '../../product/product-links/product-links.component';

@Component({
  selector: 'ish-category-categories',
  templateUrl: './category-categories.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule, FeatureToggleModule, DirectivesModule, CategoryListComponent,ProductLinksComponent],
})
export class CategoryCategoriesComponent implements OnInit, OnChanges, OnDestroy {
  private shoppingFacade = inject(ShoppingFacade);

  readonly category = input.required<CategoryView>();
  readonly deviceType = input<DeviceType>(undefined);

  productListingView$: Observable<ProductListingView>;
  private destroy$ = new Subject<void>();

  isCollapsed = false;

  ngOnInit() {
    this.isCollapsed = this.deviceType() === 'mobile';
  }

  ngOnChanges(): void {
    if (!SSR) {
      window.scroll(0, 0);
    }

    this.isCollapsed = this.deviceType() === 'mobile';

    this.shoppingFacade.loadFilterOnRouteChange();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggle() {
    this.isCollapsed = !this.isCollapsed;
    if (!SSR) {
      window.scroll(0, 0);
    }
  }
}
